import validations from './validations';
import SnapDialog from 'library-@/components/snap-ui/dialog';
import { AlertMixin } from 'library-@/mixins';
import _ from 'lodash';
import loading from '../Loading';
import showEllipsis from './show-ellipsis';
import { ImageLoader } from 'patsnap-biz';
import { formatePdfImageData } from '@/utils/pdfImageFormate';
import defaultThumbImg from '@/assets/images/pic_placeholder_120.gif';
import { emailSendApi } from '../../../../../components/apis/core_basic_api/email';

const splitEmails = string => {
    return string.split(/[,，]\s*/).filter(email => email);
};

const containInvalidEmail = emails => {
    return _.some(emails, email => {
        email = email.trim();
        return !validations.checkEmail(email);
    });
};

export default {
    name: 'EmailToFriendDialog',
    mixins: [AlertMixin],
    components: {
        SnapDialog,
        loading,
        ImageLoader,
    },
    directives: {
        showEllipsis,
    },
    filters: {
        escapeHtml: function(value) {
            if (!value) return '';
            let wrapDom = document.createElement('div');
            wrapDom.innerHTML = value;
            return wrapDom.innerText;
        },
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true,
        },
        renderViewDatas: {
            type: Object,
            required: true,
        },
        mountPoint: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            savedFlag: false,
            GdprLicence: false,
            otherEmail: '',
            siteHost: [window.location.protocol, '//', window.location.host].join(''),
            myEmail: _.get(window, 'zPREFACE.accountInfo.email', ''),
            submitLoading: false,
            hasPdf: false,
            emailToSelf: false,
            thumbImg: defaultThumbImg,
            isThumbnailError: false,
        };
    },
    computed: {
        emails() {
            const { otherEmail, emailToSelf, myEmail } = this;
            let emails = splitEmails(otherEmail);
            if (emailToSelf && !_.includes(emails, myEmail)) {
                emails = emails.concat(myEmail);
            }
            return emails;
        },
        viewLink() {
            const { renderViewDatas } = this;
            // const PnUrl = '/patent-view';
            // const interestPNlink = [PnUrl, '?patentId=', renderViewDatas.PATENT_ID].join('');
            let protocolUrl = window.location.protocol;
            let hostUrl = window.location.hostname.split('-');
            let shareUrl = '';
            if (hostUrl.length > 1) {
                shareUrl =
                    `${protocolUrl}//${hostUrl[0]}-${hostUrl[1]}/patent-view/abst?patentId=${renderViewDatas.PATENT_ID}`;
            } else {
                shareUrl = `${protocolUrl}//${hostUrl[0]}/patent-view/abst?patentId=${renderViewDatas.PATENT_ID}`;
            }
            return shareUrl;
        },
        // 包含非当前登录用户邮箱时显示
        licenceVisible() {
            // 清除红色警告
            this.savedFlag = false;
            const { emails, myEmail, otherEmail } = this;
            if (!otherEmail) return;
            return !_.every(emails, email => email === myEmail);
        },
        imageLoaderData() {
            let patentImg = this.renderViewDatas.PATSNAP_IMAGE_120 || this.renderViewDatas.PATSNAP_IMAGE;
            if (this.isThumbnailError) {
                patentImg = this.renderViewDatas.PATSNAP_IMAGE;
            }
            return formatePdfImageData(patentImg);
        },
    },
    methods: {
        showAnName(fieldItem, field, lang, index, officialValue) {
            let value = fieldItem[field][lang];
            if (_.isUndefined(value) || _.isEmpty(value) || value.length === 0) {
                return false;
            }
            if (value[index] && value[index] !== officialValue) {
                return true;
            }
            return false;
        },
        computedANEmpty(val) {
            return this.computedEmpty(val) && this.computedEmpty(val.OFFICIAL);
        },
        computedEmpty(val) {
            if (_.isEmpty(val)) {
                return false;
            }
            return true;

        },
        async submit() {
            const { emails } = this;
            let errorMessage;
            if (emails.length === 0) {
                // email is required
                errorMessage = this.$t('emailAlertDialog.noEmailAdd');
            }
            if (containInvalidEmail(emails)) {
                // email format error
                errorMessage = this.$t('emailAlertDialog.errorEmail');
            } else if (!this.GdprLicence && _.some(emails, mail => mail !== this.myEmail)) {
                // check after click submit
                // 1, 没有勾选
                // 2, 登录用户之外的邮箱地址出现时
                this.savedFlag = true;
                return;
            }
            if (errorMessage) {
                this.warnAlert(errorMessage);
                return;
            }

            this.submitLoading = true;
            try {
                await this.sendMail(emails);
                this.onClose();
                this.successAlert(this.$t('emailToFriendDialog.sendEmail'));
            } catch (error) {
                this.onClose();
                this.warnAlert(error._error_msg);
            }
            this.submitLoading = false;
        },
        sendMail(mails) {
            try {
                // 不用成功，有这个企图都算
                window.rvTrack('Share Patent', {
                    source: '/patent-view',
                    sharing_channel: 'email',
                    recipients: mails.join(', '),
                });
            } catch (e) {
                //
            }
            const { renderViewDatas, hasPdf, myEmail, otherEmail } = this;
            return emailSendApi({
                mails: mails.join(','),
                terms_of_use: myEmail !== otherEmail,
                patent_id: renderViewDatas.PATENT_ID,
                has_content: true,
                has_pdf: hasPdf,
            });
        },
        onClose() {
            this.$emit('update:showDialog', false);
        },
    },
};
